<script setup>
import { Dropdown } from 'bootstrap';
import { onMounted, ref } from 'vue';

const runtimeConfig = useRuntimeConfig();
const adminUrl = ref(runtimeConfig.public.adminUrl);

onMounted(() => {
  const dropdownElement = document.getElementById('dropdownLayoutPartsAccount');
  if (dropdownElement) {
    new Dropdown(dropdownElement);
  }
});
</script>

<template>
  <div class="dropdown dropdown__background dropdown__no-lines">
    <button
      id="dropdownLayoutPartsAccount"
      class="button button__lines-grey d-flex align-items-center"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="mx-auto" style="width: 23px">
        <span style="height: 23px; border-radius: 50%">
          <i class="fas fa-user" />
        </span>
      </span>
      <span class="d-none d-md-block ms-2">{{
        useAuth().user?.first_name
      }}</span>
    </button>
    <ul
      aria-labelledby="dropdownLayoutPartsAccount"
      class="dropdown-menu dropdown-menu-end"
    >
      <li>
        <a class="dropdown-item" :href="runtimeConfig.public.accountsUrl">
          {{ $t('account.top_menu.profile') }}
        </a>
      </li>
      <li v-if="adminUrl">
        <a class="dropdown-item" :href="adminUrl">
          {{ $t('account.top_menu.go_to_admin') }}
        </a>
      </li>
      <li>
        <nuxt-link class="dropdown-item" to="/logout">
          {{ $t('account.top_menu.logout') }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>
